<template>
  <div class="page">
    <Header title="签到" />
    <section class="sign-in-time">
      <div class="row">
        <div class="col text-center">
          <div class="sign-in-date">{{ now_datatime - 86400000 - 86400000 | parseTime('{m}月{d}日') }}</div>
          <div v-if='yesterday_before'>
            <div class="line-circle">
              <div class="circle"></div>
              <div class="signed"></div>
            </div>
            <div v-if="rule === 'IAM' || rule === 'OES'">
              <div v-if="yesterday_before_continuousCount < 6">+5</div>
              <div v-if='yesterday_before_continuousCount > 5 && yesterday_before_continuousCount < 21'>+10</div>
              <div
                v-if='yesterday_before_continuousCount > 20 && yesterday_before_continuousCount != 100 && yesterday_before_continuousCount != 200 && yesterday_before_continuousCount != 300'>
                +15</div>
              <div v-if='yesterday_before_continuousCount == 100'>+1000</div>
              <div v-if='yesterday_before_continuousCount == 200'>+2000</div>
              <div v-if='yesterday_before_continuousCount == 300'>+3000</div>
            </div>
            <div v-if="rule === 'SAH'">
              <div v-if='yesterday_before_continuousCount < 6'>+1</div>
              <div v-if='yesterday_before_continuousCount > 5 && yesterday_before_continuousCount < 11'>+2</div>
              <div
                v-if='yesterday_before_continuousCount > 10 && yesterday_before_continuousCount != 100 && yesterday_before_continuousCount != 200 && yesterday_before_continuousCount != 300'>
                +3</div>
              <div v-if='yesterday_before_continuousCount == 100'>+100</div>
              <div v-if='yesterday_before_continuousCount == 200'>+200</div>
              <div v-if='yesterday_before_continuousCount == 300'>+300</div>
            </div>

          </div>
          <div v-if='!yesterday_before'>
            <div class="line-circle">
              <div class="circle"></div>
              <div class="not-signed"></div>
            </div>
            <div>+0</div>
          </div>
        </div>
        <div class="col text-center">
          <div class="sign-in-date">{{ now_datatime - 86400000 | parseTime('{m}月{d}日') }}</div>
          <div v-if='yesterday'>
            <div class="line-circle">
              <div class="circle"></div>
              <div class="signed"></div>
            </div>
            <div v-if="rule === 'IAM' || rule === 'OES'">
              <div v-if='yesterday_continuousCount < 6'>+5</div>
              <div v-if='yesterday_continuousCount > 5 && yesterday_continuousCount < 21'>+10</div>
              <div
                v-if='yesterday_continuousCount > 20 && yesterday_continuousCount != 100 && yesterday_continuousCount != 200 && yesterday_continuousCount != 300'>
                +15</div>
              <div v-if='yesterday_continuousCount == 100'>+1000</div>
              <div v-if='yesterday_continuousCount == 200'>+2000</div>
              <div v-if='yesterday_continuousCount == 300'>+3000</div>
            </div>

            <div v-if="rule === 'SAH'">
              <div v-if='yesterday_continuousCount < 6'>+1</div>
              <div v-if='yesterday_continuousCount > 5 && yesterday_continuousCount < 11'>+2</div>
              <div
                v-if='yesterday_continuousCount > 10 && yesterday_continuousCount != 100 && yesterday_continuousCount != 200 && yesterday_continuousCount != 300'>
                +3</div>
              <div v-if='yesterday_continuousCount == 100'>+100</div>
              <div v-if='yesterday_continuousCount == 200'>+200</div>
              <div v-if='yesterday_continuousCount == 300'>+300</div>
            </div>
          </div>
          <div v-if='!yesterday'>
            <div class="line-circle">
              <div class="circle"></div>
              <div class="not-signed"></div>
            </div>
            <div>+0</div>
          </div>
        </div>
        <div class="col text-center">
          <div class="sign-in-date">今天</div>
          <div class="line-circle" @click="signIn()">
            <div class="circle-today" v-if='today'>
                <van-image :src="$getImgUrl('/img/sign-in-icon@2x.png')" fit="contain"></van-image>
              <div class="themecolor" style="font-size:0.2rem;">已签到</div>
            </div>
            <div class="circle-today" v-if='!today'>
                <van-image :src="$getImgUrl('/img/no_sign-in-icon@2x.png')" fit="contain"></van-image>
              <div class="themecolor" style="font-size:0.2rem;">签到</div>
            </div>
          </div>
        </div>
        <div class="col text-center">
          <div class="sign-in-date">{{ now_datatime + 86400000 | parseTime('{m}月{d}日') }}</div>
          <div class="line-circle">
            <div class="circle"></div>
          </div>
          <div v-if="rule === 'IAM' || rule === 'OES'">
            <div v-if='today_continuousCount < 5 || today_continuousCount == 0'>+5</div>
            <div v-if='today_continuousCount > 4 && today_continuousCount < 20'>+10</div>
            <div
              v-if='today_continuousCount > 20 && today_continuousCount != 99 && today_continuousCount != 199 && today_continuousCount != 299'>
              +15</div>
            <div v-if='today_continuousCount == 99'>+1000</div>
            <div v-if='today_continuousCount == 199'>+2000</div>
            <div v-if='today_continuousCount == 299'>+3000</div>
          </div>
          <div v-if="rule === 'SAH'">
            <div v-if='today_continuousCount < 5 || today_continuousCount == 0'>+1</div>
            <div v-if='today_continuousCount > 4 && today_continuousCount < 10'>+2</div>
            <div
              v-if='today_continuousCount > 10 && today_continuousCount != 99 && today_continuousCount != 199 && today_continuousCount != 299'>
              +3</div>
            <div v-if='today_continuousCount == 99'>+100</div>
            <div v-if='today_continuousCount == 199'>+200</div>
            <div v-if='today_continuousCount == 299'>+300</div>
          </div>
        </div>
        <div class="col text-center">
          <div class="sign-in-date">{{ now_datatime + 86400000 + 86400000 | parseTime('{m}月{d}日') }}</div>
          <div class="line-circle">
            <div class="circle"></div>
          </div>
          <div v-if="rule === 'IAM' || rule === 'OES'">
            <div v-if='today_continuousCount < 4 || today_continuousCount == 0'>+5</div>
            <div v-if='today_continuousCount > 3 && today_continuousCount < 19'>+10</div>
            <div
              v-if='today_continuousCount > 19 && today_continuousCount != 98 && today_continuousCount != 198 && today_continuousCount != 298'>
              +15</div>
            <div v-if='today_continuousCount == 98'>+1000</div>
            <div v-if='today_continuousCount == 198'>+2000</div>
            <div v-if='today_continuousCount == 298'>+3000</div>
          </div>
          <div v-if="rule === 'SAH'">
            <div v-if='today_continuousCount < 4 || today_continuousCount == 0'>+1</div>
            <div v-if='today_continuousCount > 3 && today_continuousCount < 9'>+2</div>
            <div
              v-if='today_continuousCount > 9 && today_continuousCount != 98 && today_continuousCount != 198 && today_continuousCount != 298'>
              +3</div>
            <div v-if='today_continuousCount == 98'>+100</div>
            <div v-if='today_continuousCount == 198'>+200</div>
            <div v-if='today_continuousCount == 298'>+300</div>
          </div>
        </div>
      </div>
    </section>
    <div class="text-center container">
      你已经连续签到 <span style="color:#00545e;font-size:0.45rem;">{{ signDate }}</span> 天
    </div>
    <section>
      <div class="row container text-center" v-if="pagination.show">
        <div class="col-33">签到日期</div>
        <div class="col-33">签到来源</div>
        <div class="col-33">签到积分</div>
      </div>

      <div class="row container text-center" style="height:0.6rem;" v-for="(signItem,index) in signList" :key="index">
        <div class="col-33">{{signItem.signDate | parseTime('{y}-{m}-{d}')}}</div>
        <div class="col-33">{{signItem.signFrom}}</div>
        <div class="col-33">{{signItem.pointTypeName}}+{{signItem.pointValue}}</div>
      </div>
      <div class="pagination">
        <van-pagination v-model="pagination.currentPage" :total-items="pagination.totalItems" :items-per-page="5"
          :show-page-size="5" force-ellipses v-if="pagination.show" @change="changePage">
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
        </van-pagination>
      </div>
    </section>
    <div class="container">
      <van-image :src="$getImgUrl('/img/sign-rule.jpg')" v-if="rule==='IAM'"></van-image>
      <van-image :src="$getImgUrl('/img/sign-rule2.jpg')" v-if="rule==='OES'"></van-image>
      <van-image :src="$getImgUrl('/img/sign-rule_3.jpg')" v-if="rule ==='SAH'"></van-image>
    </div>
    <SignInDisplay :show.sync="signInDisplay.dialog" :displayString="signInDisplay.displayString" :linkCoupon="signInDisplay.linkCoupon"></SignInDisplay>
    <popUpDisplay :show.sync="popUpDisplay.dialog" :activityPrize="popUpDisplay.activityPrize" :type="popUpDisplay.type"  ></popUpDisplay>
  </div>
</template>

<script>
import Header from '@/components/header'
import SignInDisplay from './component/sign-in-display.vue'
import { mapState } from 'vuex'
import cartApi from '@/api/cart'
import { commonUtils } from '@/utils/common'
import popUpDisplay from '../../components/popup-cards.vue'
export default {
  components: {
    Header,
    SignInDisplay,
    popUpDisplay
  },
  data () {
    return {
      now_datatime: (new Date()).valueOf(),
      rule: '',
      threety_datatime: '',

      yesterday: false,
      yesterday_time: '',
      yesterday_continuousCount: 0,

      yesterday_before: false,
      yesterday_before_time: '',
      yesterday_before_continuousCount: 0,

      today: false,
      today_continuousCount: 0,

      signList: [],
      signDate: 0,
      pagination: {
        show: false,
        currentPage: 1,
        totalItems: 0
      },

      pieceInfo: {
        pieceCode: '',
        pieceUrl: ''
      },
      signInDisplay: {
        dialog: false,
        displayString: '',
        linkCoupon: false
      },
      popUpDisplay: {
        dialog: false,
        activityPrize:{},
        type:'sign'
      }
    }
  },
  computed: {
    ...mapState({
      // filePrefix: state => state.base.ApiEndpoint.fileUrl,
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  created () {
    this.rule = this.clientInfo.marketName
    this.threety_datatime = this.now_datatime - 2592000000
    this.yesterday_time = this.now_datatime - 86400000
    this.yesterday_before_time = this.now_datatime - 86400000 - 86400000
    this.getSignList()
  },
  methods: {
    getSignList () {
      let params = {
        page: this.pagination.currentPage,
        pageSize: 5
      }
      cartApi.getSignList(params).then(res => {
        if (res.data.resultCode === '0') {
          const { signList, pageInfo } = res.data.resultData

          this.pagination.totalItems = pageInfo.totalCounts || 0

          this.signList = signList || []
          if (this.signList.length) {
            this.signDate = signList[0].continuousCount
            // 定义昨天前天的签到状态
            for (let i = 0; i < signList.length; i++) {
              let dt1 = commonUtils.parseTime(signList[i].signDate, '{y}-{m}-{d}')
              if (dt1 === commonUtils.parseTime(this.yesterday_time, '{y}-{m}-{d}')) {
                this.yesterday = true
                this.yesterday_continuousCount = signList[i].continuousCount
              }
            }
            for (let i = 0; i < signList.length; i++) {
              let dt2 = commonUtils.parseTime(signList[i].signDate, '{y}-{m}-{d}')
              if (dt2 === commonUtils.parseTime(this.yesterday_before_time, '{y}-{m}-{d}')) {
                this.yesterday_before = true
                this.yesterday_before_continuousCount = signList[i].continuousCount
              }
            }
            for (var i = 0; i < signList.length; i++) {
              let dt3 = commonUtils.parseTime(signList[i].signDate, '{y}-{m}-{d}')
              if (dt3 === commonUtils.parseTime(this.now_datatime, '{y}-{m}-{d}')) {
                this.today = true
                this.today_continuousCount = signList[i].continuousCount
              }
            }
          }

          if (this.pagination.totalItems === 0) {
            this.pagination.show = false
          } else {
            this.pagination.show = true
          }
        }
      })
    },
    changePage () {
      this.getSignList()
    },
    signIn () {
      let data = {
        'signFrom': 'app'
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })

      cartApi.signIn(data).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          if(res.data.resultData.activityPrize){
            this.popUpDisplay.dialog = true 
            this.popUpDisplay.activityPrize = res.data.resultData.activityPrize
          }
          this.today = true
          let title = '恭喜您,今日签到成功!' + this.getResponseText(res.data.resultData) + this.getSpecialResponseText(res.data.resultData)
          if (res.data.resultData.signGetRefuel === 'succeed') {
            this.$dialog.alert({ message: title }).then(() => {
              this.$dialog.confirm({
                title: '温馨提示',
                message: '恭喜您签到成功，获得500ml油量！',
                confirmButtonText: '返回活动首页',
                cancelButtonText: '取消'
              }).then(() => {
                this.$router.push({
                  name: 'activity-refuel'
                })
              }).catch(() => { })
            })
          }
          if (res.data.resultData.displayString) {
            // 签到三天活动
            this.signInDisplay.dialog = true
            this.signInDisplay.displayString = res.data.resultData.displayString
            // 小工不跳转卡券
            this.signInDisplay.linkCoupon = this.userRole !== '03'
          }
          // this.signInDialog = true
          this.pagination.currentPage = 1
          this.getSignList()
        }
      }).catch(() => { this.$toast.clear() })
    },
    getResponseText (resultData) {
      if (!resultData.pointTypeName) {
        return ''
      } else if (resultData.pointTypeName) {
        return resultData.pointTypeName + '+' + (resultData.pointValue || '0')
      }
    },
    getSpecialResponseText (resultData) {
      if (!resultData.signInAcquireCoin) {
        return ''
      } else if (resultData.signInAcquireCoin) {
        return ',额外获得金币' + '+' + resultData.coinQuantity
      }
    }
  }
}
</script>
<style  scoped lang="less">
/* 签到 */
.sign-in-time {
  width: 100%;
  height: 3rem;
  color: #fff;
  background-color: #117281;
}

.sign-in-time .col {
  padding: 0;
  flex: 1;
  display: block;
  width: 100%;
}

.sign-in-time .sign-in-date {
  padding-top: 0.3rem;
  font-size: 0.3rem;
}

.sign-in-time .line-circle {
  position: relative;
  margin-top: 0.8rem;
  margin-bottom: 0.5rem;
  border: 1px solid #fff;
}

.sign-in-time .line-circle .circle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.6rem;
  height: 0.6rem;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: #fff;
}

.sign-in-time .line-circle .signed {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.2rem;
  height: 0.2rem;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: #117281;
}

.sign-in-time .line-circle .not-signed {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.2rem;
  height: 0.2rem;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: #50c3c8;
}

.sign-in-time .line-circle .circle-today {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.5rem;
  height: 1.5rem;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: #fff;
  -webkit-box-shadow: 0 0 0 0.05rem #599da7;
  box-shadow: 0 0 0 0.05rem #599da7;
}

.sign-in-time .line-circle .van-image {
  // width: 0.5rem;
  height: 0.5rem;
  margin-top: 0.3rem;
}

.row {
  display: flex;
  padding: 0;
  width: 100%;
}
.col-33{
  flex: 0 0 33.3333%;
  max-width: 33.3333%;
}
.container {
  margin: 0.3rem 0rem;
  font-size: 0.35rem;
}
.pagination {
    display: flex;
    justify-content: center;
    /deep/ .van-pagination__item{
    height: 0.75rem;
    color:#117281;
    border: 1px solid #599da7;
    min-width: 0.75rem;
    }
    /deep/ .van-pagination__item--active{
      color: #fff;
      background-color: #117281;
    }
    /deep/ .van-pagination__item:active{
        color: #fff;
      background-color: #117281;
    }
}
</style>
